import React from 'react';
import CalendarComponent from 'components/Calendar';

const Calendar = () => {
  return <CalendarComponent />;
};

export default Calendar;

